var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onClickOutside,
          expression: "onClickOutside"
        }
      ],
      staticClass: "relative w-full"
    },
    [
      _c(
        "button",
        {
          staticClass:
            "flex items-center justify-between w-full px-4 py-2 font-medium appearance-none bg-light-blue-0 focus:outline-none text-blue-1",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              _vm.isOpen = !_vm.isOpen
            }
          }
        },
        [
          _vm.selectedOption
            ? _c("span", { staticClass: "mr-6" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.selectedOption.$el.innerText) +
                    "\n        "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "svg",
            {
              staticClass:
                "w-4 h-4 transition-transform duration-200 origin-center transform text-blue-1",
              class: { "rotate-180": _vm.isOpen },
              attrs: { fill: "none", viewBox: "0 0 24 24" }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M18.885 7L12 13.799 5.115 7 3 9.093 12 18l9-8.907L18.885 7z",
                  fill: "currentColor"
                }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("collapse-transition", { ref: "dropdownMenu" }, [
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpen,
                expression: "isOpen"
              }
            ],
            staticClass: "absolute w-full bg-white shadow-md"
          },
          [_vm._t("default", null, { selectOption: _vm.selectOption })],
          2
        )
      ]),
      _vm._v(" "),
      _vm.selectedOption
        ? _c("input", {
            attrs: { type: "hidden", name: _vm.name },
            domProps: { value: _vm.selectedOption.value }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }